import { Button, Layout, Modal, Space, Tabs, Typography } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import "./prestations.css";

import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { IoAddSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import routes from "../../../engine/routes";
import { getPrestations } from "../Slices/Prestations.slice";
import CustomTable from "../../../shared/components/CustomTable";
import {
  onlyRoleMapping,
  UserCanDoActionMemo,
  userHasLevel,
} from "../../../engine/AuthRoute";
import {
  renderStatusPrestation,
  roles,
  statusPrestationsValues,
  subRoles,
} from "../../../utils/constants";
import { objectToUrlParams } from "../../../utils/helpersFunction";
import dayjs from "../../../utils/dayjs";
import { clearPrestation } from "../Slices/Prestation.slice";
import {
  columnsPrestationsList,
  defaultSorterByTab,
  inputsPrestationsList,
} from "./Prestations.list.constants";
import { useTranslation } from "react-i18next";
import { newPrestationSelectors } from "../../../shared/components/Modals/modals";
import { UserContext } from "../../../engine/context/User.context";
import { IoMdDownload } from "react-icons/io";
import { BillsExportsExcel } from "../../Billing/BillingList/BillsExportsExcel";
import _ from "lodash";
import { http } from "../../../engine/api/http";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { CgDanger } from "react-icons/cg";

const { Content } = Layout;

export function PrestationsList(props) {
  const { prestations, loading, totals } = useSelector(
    state => state.prestations,
  );

  const [loadingExport, setLoadingExport] = useState(false);
  const [showModalExport, setModalEport] = useState(false);

  const { configuration } = useContext(UserContext);

  const { t } = useTranslation();
  const formRef = useRef(null);

  const now = dayjs();
  let monthNexts = 1;
  if (onlyRoleMapping([roles.institution, roles.interprete])) {
    monthNexts = 12;
  }

  // const monthsAfter = now.add(monthNexts, "month");
  //
  // const threeMonthsBefore = now.subtract(1, "month");

  const defaultRanges = [undefined, undefined];
  const searcher = localStorage.getItem("prestationsSearcher");

  let searcherObj = {};
  try {
    searcherObj = searcher ? JSON.parse(searcher) : {};
  } catch {
    searcherObj = {};
  }

  const initialSearchState = (() => {
    const s = { ...(searcherObj?.searchState || {}) };
    if (s.soledeSync != null && s.soledeStatus == null) {
      s.soledeStatus = s.soledeSync;
      delete s.soledeSync;
    }
    return s;
  })();

  const [advancedSearch, setAdvancedSearch] = React.useState(
    searcherObj?.advancedSearch || false,
  );

  const [tab, setTab] = React.useState(searcherObj?.tab || "schedules");

  const [searchState, setSearchState] = React.useState(initialSearchState);

  const defaultPagination = {
    totalPages: 0,
    currentPage: 1,
    pageSize: 100,
    sorter: defaultSorterByTab(tab),
  };

  const [pagination, setPagination] = React.useState(
    searcherObj?.pagination || defaultPagination,
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onChangeTab = (tab, p, r) => {
    setPagination({
      ...defaultPagination,
      sorter: defaultSorterByTab(tab),
      pageSize: pagination.pageSize,
    });
    setTab(tab);
  };

  // useEffect(() => {
  //   // setPagination({ ...pagination, sorter: defaultSorterByTab(tab) });
  // }, [tab]);

  const dispatchActionPrestations = React.useCallback(() => {
    const search = objectToUrlParams({
      ...searchState,
      tab,
      ...pagination,
    });
    dispatch(getPrestations({ search }));
  }, [dispatch, searchState, tab, pagination]);

  useEffect(() => {
    dispatchActionPrestations();

    const searcherPayload = {
      tab,
      searchState,
      pagination,
      advancedSearch,
    };

    localStorage.setItem("prestationsSearcher", JSON.stringify(searcherPayload));
  }, [tab, searchState, pagination, dispatchActionPrestations]);

  const handleKeyUp = async event => {
    // Enter
    if (event.keyCode === 13) {
      formRef.current.submit();
    }

    // if (event.code === "Backspace" || event.code === "Delete") {
    //   setSearchState({});
    //
    //   formRef.current.resetFields(); // Reset the form fields using the ref
    //   // formRef.current.setFieldsValue(initialValuesForm);
    //   setPagination(defaultPagination);
    //   await dispatchActionPrestations();
    // }
  };

  useEffect(() => {
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyUp]);

  const onValuesChange = (changedValues, allValues) => {
    // Object.keys(changedValues).map(changed => {
    //   switch (changed) {
    //     case "reference":
    //       if (
    //         changedValues[changed].length > 3 ||
    //         changedValues[changed].length === 0
    //       ) {
    //         setSearchState(allValues);
    //       }
    //
    //       break;
    //     default:
    //       setSearchState(allValues);
    //       break;
    //   }
    // });
  };

  const handleSubmit = data => {
    if (
      data?.rangeDate === undefined ||
      data?.rangeDate === null ||
      data?.rangeDate === undefined ||
      data?.rangeDate[0] === undefined ||
      data?.rangeDate[1] === undefined
    ) {
      delete data.rangeDate;
    }

    if (data.reference === null) {
      delete data.reference;
    }
    setSearchState(data);
  };

  const newPrestationLink = async () => {
    newPrestationSelectors({
      onOk: async () => {},
      content: {
        navigate,
      },
    });

    await dispatch(clearPrestation());
    // navigate(routes.prestations("new").detail.path);
  };

  const smTitle = item => {
    return (
      <div className={"alignHeaderPage"}>
        {renderStatusPrestation(item, {
          showControls: userHasLevel({
            only: {
              [roles.permanance]: "crud",
              [roles.admin]: "crud",
            },
          }),
        })}
        <Typography ellipsis={true} level={3}>
          {item?.institution?.name === undefined
            ? item?.reference
            : item?.institution?.name}
        </Typography>
      </div>
    );
  };

  const isAdmin = userHasLevel({
    only: {
      [roles.admin]: "crud", //
      [roles.permanance]: "crud", //
    },
  });

  const renderTableSorted = (sortedData, key) => {
    return (
      <CustomTable
        scroll={{ y: 1000, x: searchState.advancedCols === true ? 2000 : 800 }}
        key={key}
        loading={loading}
        smTitle={smTitle}
        onRowLink={record => routes.prestations(record._id).detail.path}
        dataSource={sortedData}
        columns={columnsPrestationsList(sortedData, searchState)}
        rowKey="_id"
        pagination={{
          hideOnSinglePage: false,
          position: ["topRight"],
          defaultPageSize: pagination.pageSize,
          pageSizeOptions: [...[10, 20, 50, 100, 250]],
          showSizeChanger: true,
          current: pagination.currentPage,
          total: totals[key],
          showTotal: (total, range) => (
            <span>
              {advancedSearch && searchState?.advancedCols && isAdmin ? (
                <Button
                  loading={loadingExport}
                  size={"small"}
                  type={"primary"}
                  style={{ marginRight: 10 }}
                  onClick={async () => {
                    if (total > 5000) {

                      setModalEport(true)
                    } else {
                      setLoadingExport(true);

                      const search = objectToUrlParams({
                        ...searchState,
                        tab,
                        currentPage: 1,
                        pageSize: 5000,
                        sorter: {
                          key: "finalStartDate",
                          order: "descend",
                        },
                      });


                      const datatoexport = await http.get(
                        `/prestations/tab?${search}`,
                      );


                      let clone = _.cloneDeep(datatoexport.data.prestations).map(e => {
                        if (e.bill !== null) {
                          return {
                            ...e,
                            bill: {
                              ...e.bill,
                              institution: e.institution,
                            },
                          };
                        } else {
                          return e;
                        }
                      });
                      await BillsExportsExcel(clone, false);
                      setLoadingExport(false);
                    }
                  }}
                >
                  <Space>
                    <IoMdDownload />
                    {t("PrestationsList2.exportPrestations")}
                  </Space>
                </Button>
              ) : null}
              {`${range[0]}-${range[1]} ${t(
                "PrestationsList2.showTotal",
              )} ${total} ${t("PrestationsList2.items")}`}
            </span>
          ),
        }}
        onChange={async (p, filters, sorter, extra) => {
          let extraSorter = {};

          if (sorter.order !== undefined) {
            extraSorter = {
              sorter: {
                key: sorter.columnKey,
                order: sorter.order,
              },
            };
          } else {
            extraSorter = {
              sorter: defaultPagination.sorter,
            };
          }

          setPagination({
            currentPage: p.current,
            pageSize: p.pageSize,
            ...extraSorter,
          });
        }}
      />
    );
  };

  const renderAVenir = () => {
    const key = "schedules";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.upcoming")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };
  const renderAVenir24h = () => {
    const key = "min72h";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.upcoming72h")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  const renderToday = () => {
    const now = dayjs(); // Current date and time
    const startOfDay = now.startOf("day"); // Start of the current day (00:00)
    const endOfDay = now.endOf("day"); // End of the current day (23:59)

    const todayPrestations = prestations.filter(item => {
      const startDate = dayjs(item.finalStartDate);
      return startDate.isAfter(startOfDay) && startDate.isBefore(endOfDay);
    });

    const sorted = todayPrestations.sort((a, b) =>
      dayjs(a.finalStartDate).isBefore(dayjs(b.finalStartDate)) ? -1 : 1,
    );
    const key = "today";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.today")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  const renderAFinalise = () => {
    const sorted = prestations.filter(prestation => {
      return [
        statusPrestationsValues.draft,
        statusPrestationsValues.waiting,
      ].includes(prestation.status);
    });
    const key = "draft";

    return onlyRoleMapping([
      roles.admin,
      roles.permanance,
      roles.institution,
    ]) ? (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.drafts")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    ) : null;
  };

  const renderWaiting = () => {
    const key = "waiting";

    return onlyRoleMapping([
      roles.admin,
      roles.permanance,
      roles.institution,
    ]) ? (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.waiting")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    ) : null;
  };
  const renderAccepter = () => {
    const key = "toConfirm";

    return onlyRoleMapping([
      roles.interprete,
      roles.institution,
      subRoles.institutionDemander,
      subRoles.institutionAdmin,
    ]) ? (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.toAccept")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    ) : null;
  };

  const renderTerminee = () => {
    const sorted = prestations.filter(prestation => {
      return [
        statusPrestationsValues.finish,
        statusPrestationsValues.finish_permanance,
        statusPrestationsValues.finish_notsigned,
      ].includes(prestation.status);
    });
    const key = "done";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.completed")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  const renderRetard = () => {
    const now = dayjs(); // Obtenez la date et l'heure actuelles

    const enRetard = prestations.filter(item => {
      const endDate = dayjs(item.finalEndDate);
      return (
        endDate.isBefore(now) && item.status === statusPrestationsValues.planned
      );
    });

    const key = "nonClosed";

    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.notClosed")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  const renderAnnule = () => {
    const key = "cancelled";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.cancelled")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };
  const renderToutes = () => {
    const key = "total";
    return (
      <Tabs.TabPane
        disabled={loading}
        tab={`${t("PrestationsList2.all")} (${totals[key]})`}
        key={key}
      >
        {key === tab ? renderTableSorted(prestations, key) : null}
      </Tabs.TabPane>
    );
  };

  return (
    <>
      <Content>
        <Space
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography.Title level={2} className={""}>
            {t("prestations.Prestations")}
          </Typography.Title>

          <UserCanDoActionMemo
            route={routes.prestations("new").detail}
            action={"c"}
          >
            <a onClick={newPrestationLink}>
              <Button
                size={"large"}
                type={"primary"}
                style={{
                  justifySelf: "flex-start",
                  display: "flex",
                }}
                icon={
                  <IoAddSharp
                    style={{
                      marginTop: "0px",
                    }}
                    size={25}
                  />
                }
              >
                {t("PrestationsList2.newPrestation")}
              </Button>
            </a>
          </UserCanDoActionMemo>
        </Space>
        <CustomForm
          dataSource={inputsPrestationsList(
            defaultRanges,
            formRef,
            setSearchState,
            setPagination,
            dispatchActionPrestations,
            defaultPagination,
            loading,
            searchState,
            advancedSearch,
            setAdvancedSearch,
          )}
          onKeyUp={handleKeyUp}
          labelCol={24}
          wrapperCol={24}
          resetOnFinish={undefined}
          refForm={formRef}
          onValuesChange={onValuesChange}
          handleSubmit={handleSubmit}
        />
        <Tabs
          onChange={onChangeTab}
          defaultActiveKey={tab}
          type={"card"}
          size={"large"}
          className={"prestations-tabs"}
        >
          {renderAccepter()}
          {renderAFinalise()}
          {renderWaiting()}
          {renderAVenir()}
          {renderToday()}
          {configuration?.prestation?.showList72h && renderAVenir24h()}
          {renderTerminee()}
          {renderRetard()}
          {renderAnnule()}
          {renderToutes()}
        </Tabs>
      </Content>
      <Modal
        title={<Space><CgDanger color={"red"} size={25} />{t("PrestationsList2.exporttitle")}</Space>}
        open={showModalExport}
        onOk={() => setModalEport(false)}
        okText={t("PrestationsList2.completed")}
        footer={[
          <Button key="ok" type="primary" onClick={() => setModalEport(false)}>
            {t("PrestationsList2.completed")}
          </Button>,
        ]}
      >
        <p>{t("PrestationsList2.exportmessage")}</p>
      </Modal>
    </>
  );
}
